/* eslint-disable react/require-default-props */

/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React from 'react';

// import * as AppPropTypes from '../../lib/PropTypes';
import PageMeta from '../partials/PageMeta';

import styles from '../../styles/pages/error.module.css';

const propTypes = {
    statusCode: PropTypes.number,
};

function ErrorPage({ statusCode = 404 }) {
    return (
        <div className={styles.container}>
            <PageMeta title={statusCode || 404} />
            <div className={styles.inner}>
                <h1 className={styles.title}>{statusCode}</h1>
            </div>
        </div>
    );
}

ErrorPage.propTypes = propTypes;

export default ErrorPage;
